import * as React from "react";
import { forwardRef } from "react";
const SvgStatusDot = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.001 8.001a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z" }));
const ForwardRef = forwardRef(SvgStatusDot);
export default ForwardRef;
